import { render, staticRenderFns } from "./outage-clock.vue?vue&type=template&id=65dd17b0"
import script from "./outage-clock-component.ts?vue&type=script&lang=ts&external"
export * from "./outage-clock-component.ts?vue&type=script&lang=ts&external"
import style0 from "./outage-clock.less?vue&type=style&index=0&lang=less&external"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/src/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('65dd17b0')) {
      api.createRecord('65dd17b0', component.options)
    } else {
      api.reload('65dd17b0', component.options)
    }
    module.hot.accept("./outage-clock.vue?vue&type=template&id=65dd17b0", function () {
      api.rerender('65dd17b0', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/outage-clock/clock/outage-clock.vue"
export default component.exports